export const HM_AKAMAI_PREFIX = 'https://image.hm.com/assets/hm/';
export const DEFAULT_IMAGE_EXTENSION = '.jpg';
//# sourceMappingURL=constants.js.map